module.exports = __webpack_public_path__ + "img/bell.a40d2e9d.svg";